/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/assets/js/video-slider.js ***!
  \***************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var VideoSlider = /*#__PURE__*/function (_HTMLElement) {
  _inherits(VideoSlider, _HTMLElement);

  var _super = _createSuper(VideoSlider);

  function VideoSlider() {
    var _this;

    _classCallCheck(this, VideoSlider);

    _this = _super.call(this);
    _this.selectors = {
      videoSlider: ".video-swiper",
      reviewSliderContainer: ".review-slider .swiper",
      bigCustomerReview: ".customer_reviews_slider",
      reviewSlider: ".review-slider",
      popup: ".customer-video-popup"
    };
    _this.videoSlider = null;
    _this.reviewSlider = null;
    _this.videoSliderSettings = {};
    _this.reviewSliderSettings = {};
    _this.activeVideoId = null;
    _this.activeVideo = null;
    _this.activeVideoWrapper = null;
    return _this;
  }

  _createClass(VideoSlider, [{
    key: "initVideoSlider",
    value: function initVideoSlider() {
      var _this2 = this;

      var slider = this.querySelector(this.selectors.videoSlider);
      var nextButton = this.querySelector('.swiper-button-next--top-video');
      var prevButton = this.querySelector('.swiper-button-prev--top-video');
      this.videoSlider = new Swiper(slider, _objectSpread({
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        }
      }, this.videoSliderSettings));

      if (this.querySelector('.video-swiper-container-video')) {
        this.resizeVideoTextContainer();
        window.addEventListener('resize', function () {
          _this2.resizeVideoTextContainer();
        });
      }
    }
  }, {
    key: "resizeVideoTextContainer",
    value: function resizeVideoTextContainer() {
      var maxHeight = 0;
      var videoTextContainers = this.querySelectorAll('.video-swiper .swiper-slide .video-text-container');

      if (!videoTextContainers.length) {
        return;
      }

      videoTextContainers.forEach(function (container) {
        if (container.clientHeight > maxHeight) {
          maxHeight = container.clientHeight;
        }
      });
      videoTextContainers.forEach(function (container) {
        container.style.height = maxHeight + 'px';
      });
    }
  }, {
    key: "initReviewSlider",
    value: function initReviewSlider() {
      var slider = this.querySelector(this.selectors.reviewSliderContainer);
      var slideBigContainer = this.querySelector(this.selectors.bigCustomerReview);
      var nextButton = slideBigContainer.querySelector('.swiper-button-next');
      var prevButton = slideBigContainer.querySelector('.swiper-button-prev');
      var pagination = slideBigContainer.querySelector('.swiper-pagination') ? slideBigContainer.querySelector('.swiper-pagination') : false;

      if (pagination) {
        this.reviewSliderSettings = _objectSpread({
          pagination: {
            el: pagination,
            clickable: true
          }
        }, this.reviewSliderSettings);
      }

      this.reviewSlider = new Swiper(slider, _objectSpread({
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        }
      }, this.reviewSliderSettings));

      if (this.syncSliders) {
        this.reviewSlider.controller.control = this.videoSlider;
      }
    }
  }, {
    key: "startVideo",
    value: function startVideo() {
      var popup = this.querySelector(this.selectors.popup);

      if (popup.querySelector('.mobile-video') && popup.querySelector('video[data-video-id="' + this.activeVideoId + '"].mobile-video')) {
        if (window.innerWidth < 1024) {
          this.activeVideo = popup.querySelector('video[data-video-id="' + this.activeVideoId + '"].mobile-video');
        } else {
          this.activeVideo = popup.querySelector('video[data-video-id="' + this.activeVideoId + '"].desktop-video');
        }

        this.activeVideoWrapper = this.activeVideo.closest('.customer-video-popup__video');
        this.activeVideoWrapper.classList.remove('hidden');

        if (this.activeVideo) {
          this.activeVideo.play();
        }
      } else {
        this.activeVideo = popup.querySelector('video[data-video-id="' + this.activeVideoId + '"]');
        this.activeVideoWrapper = this.activeVideo.closest('.customer-video-popup__video');
        this.activeVideoWrapper.classList.remove('hidden');

        if (this.activeVideo) {
          this.activeVideo.play();
        }
      }
    }
  }, {
    key: "stopVideo",
    value: function stopVideo() {
      if (this.activeVideo) {
        this.activeVideo.currentTime = 0;
        this.activeVideo.pause();
        this.activeVideoWrapper.classList.add('hidden');
        this.activeVideo = null;
      }
    }
  }, {
    key: "openPopup",
    value: function openPopup() {
      var popup = this.querySelector(this.selectors.popup);
      popup.classList.add('show');
      this.startVideo();
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      var popup = this.querySelector(this.selectors.popup);
      this.stopVideo();
      popup.classList.remove('show');
    }
  }, {
    key: "playVideo",
    value: function playVideo(e) {
      var videoId = this.activeVideoId;
      var video = document.querySelector('.video_slide[data-video-id="' + videoId + '"]');
      var videos = this.querySelectorAll('.video_slide');

      if (video.paused) {
        // Play the clicked video
        videos.forEach(function (v) {
          v.pause();

          if (v.closest('[data-videotrigger]')) {
            v.closest('[data-videotrigger]').classList.remove('play-icon--playing');
          }
        });
        e.currentTarget.classList.add('play-icon--playing');
        video.play();
      } else {
        // Pause the clicked video
        video.pause();
        e.currentTarget.classList.remove('play-icon--playing');
      }
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      var _this3 = this;

      var playIcons = this.querySelectorAll('[data-videotrigger]');
      var closePopupButton = this.querySelector('[data-close-popup]');
      var popup = this.querySelector(this.selectors.popup);
      var videosInPopup = popup.querySelectorAll('video');

      if (playIcons.length) {
        playIcons.forEach(function (playIcon) {
          playIcon.addEventListener('click', function (e) {
            _this3.activeVideoId = e.currentTarget.getAttribute('data-video-id');

            if (window.innerWidth < 1024 && _this3.showMobilePopup) {
              _this3.openPopup();
            } else if (window.innerWidth > 1024 && _this3.showDesktopPopup) {
              _this3.openPopup();
            } else {
              _this3.playVideo(e);
            }
          });
        });
      }

      if (videosInPopup.length) {
        videosInPopup.forEach(function (video) {
          video.addEventListener('ended', function () {
            _this3.closePopup();
          });
        });
      }

      if (closePopupButton) {
        closePopupButton.addEventListener('click', function (e) {
          _this3.closePopup();
        });
      }

      if (popup) {
        popup.addEventListener('click', function (e) {
          if (e.target === popup) {
            _this3.closePopup();
          }
        });
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;

      document.addEventListener("DOMContentLoaded", function () {
        _this4.initVideoSlider();

        _this4.initReviewSlider();

        _this4.initListeners();
      });
    }
  }]);

  return VideoSlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('video-slider')) {
  customElements.define('video-slider', VideoSlider);
}
/******/ })()
;